var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UserLayout',{attrs:{"pageTitle":"Gestione permessi"},scopedSlots:_vm._u([{key:"page-content",fn:function(props){return [_c('FrmManagePermissions')]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }